module.exports = new __parcel__URL__("place1.d8207365.ogg").toString();